import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Tooltip,
} from 'chart.js';
import { memo } from 'react';
import { Bar } from 'react-chartjs-2';

import { WorkOrderData } from '../../../../api/workOrders/types';
import { CHART_TITLES } from '../../constants';
import { groupByCompany } from '../../utils/aggregations';
import { ChartCard } from '../ChartCard';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  Tooltip,
  BarController
);

const colorFor = (overduePct: number): string => {
  if (overduePct >= 50) return '#F50606';
  if (overduePct >= 20) return '#E67715';
  return '#43A047';
};

interface TopCompaniesProps {
  data: WorkOrderData[];
}

function TopCompaniesImpl({ data }: TopCompaniesProps): JSX.Element {
  const stats = groupByCompany(data, 10);
  const chartData = {
    labels: stats.map((s) => s.company),
    datasets: [
      {
        label: 'OS',
        data: stats.map((s) => s.count),
        backgroundColor: stats.map((s) => colorFor(s.overduePct)),
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx: { dataIndex: number; raw: unknown }) => {
            const s = stats[ctx.dataIndex];
            return ` ${s.count} OS • ${s.overduePct}% atrasadas`;
          },
        },
      },
    },
    scales: {
      x: { beginAtZero: true, ticks: { precision: 0 } },
    },
  };

  return (
    <ChartCard
      title={CHART_TITLES.topCompanies}
      ariaLabel={`Top ${stats.length} fornecedores por volume de OS: ${stats
        .map((s) => `${s.company} ${s.count} OS, ${s.overduePct}% atrasadas`)
        .join('; ')}.`}
    >
      <Bar data={chartData} options={options} />
    </ChartCard>
  );
}

export const TopCompanies = memo(TopCompaniesImpl);
